<template>
  <span>
    <settings-icon
      v-if="addIconVisible"
      class="pull-right"
      name="add"
      @clicked="$emit('add')"
    />
    <settings-icon
      v-if="editIconVisible"
      class="pull-right"
      @clicked="$emit('edit')"
    />
  </span>
</template>

<script>
import SettingsIcon from '@/modules/entry-form/Configuration/SettingsIcon.vue';

export default {
  components: {
    SettingsIcon
  },
  props: {
    addIconVisible: {
      type: Boolean,
      default: true
    },
    editIconVisible: {
      type: Boolean,
      default: true
    }
  }
};
</script>
